import type { paths } from '@orlikfy/api-interfaces';

export { NotificationDto } from '@orlikfy/api-interfaces';

// GET /user-notifications
export const GET_USER_NOTIFICATIONS_PATH = '/user-notifications' as const satisfies keyof paths;
type GetUserNotificationsOperation = paths[typeof GET_USER_NOTIFICATIONS_PATH]['get'];
export type GetUserNotificationsResponse =
  GetUserNotificationsOperation['responses'][200]['content']['application/json'];

// PATCH /user-notifications
export const MARK_NOTIFICATIONS_AS_READ_PATH = '/user-notifications' as const satisfies keyof paths;
type MarkNotificationsAsReadOperation = paths[typeof MARK_NOTIFICATIONS_AS_READ_PATH]['patch'];
export type MarkNotificationsAsReadBody =
  MarkNotificationsAsReadOperation['requestBody']['content']['application/json'];

// PATCH /user-notifications/{notificationId}/mark-as-clicked
export const MARK_NOTIFICATION_AS_CLICKED_PATH =
  '/user-notifications/{notificationId}/mark-as-clicked' as const satisfies keyof paths;
type MarkNotificationAsClickedOperation = paths[typeof MARK_NOTIFICATION_AS_CLICKED_PATH]['patch'];
export type MarkNotificationAsClickedPathParams = MarkNotificationAsClickedOperation['parameters']['path'];

// PUT /user-notifications/config/register-device-token
export const REGISTER_DEVICE_TOKEN_PATH =
  '/user-notifications/config/register-device-token' as const satisfies keyof paths;
type RegisterDeviceTokenOperation = paths[typeof REGISTER_DEVICE_TOKEN_PATH]['put'];
export type RegisterDeviceTokenBody = RegisterDeviceTokenOperation['requestBody']['content']['application/json'];

// DELETE /user-notifications/config/unregister-device-token/{token}
export const UNREGISTER_DEVICE_TOKEN_PATH =
  '/user-notifications/config/unregister-device-token/{token}' as const satisfies keyof paths;
type UnregisterDeviceTokenOperation = paths[typeof UNREGISTER_DEVICE_TOKEN_PATH]['delete'];
export type UnregisterDeviceTokenPathParams = UnregisterDeviceTokenOperation['parameters']['path'];
